import { apiAbortController, TransactionType, Response } from '@ui/src';
import api from '../../../api/api';
import { TransactionStatusReportResponse } from '../types';

export const transactionStatusApi = api.injectEndpoints({
  endpoints: (build) => ({
    getReportsTransactionsTypes: build.query<Response<TransactionType>, void>({
      query: () => ({
        url: `/v1/transactions-types`,
      }),
    }),
    getTransactionStatusReport: build.query<
      { data: TransactionStatusReportResponse },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `/v1/reports/transactions-stats-by-status?typeId=${id}&format=TOTALS_PER_STATUS_PER_CURRENCY`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetTransactionStatusReportQuery,
  useLazyGetReportsTransactionsTypesQuery,
} = transactionStatusApi;

export const {
  endpoints: { getTransactionStatusReport, getReportsTransactionsTypes },
} = transactionStatusApi;
